import {
  DynamicForm,
  DynamicFormEvent,
  DynamicFormService,
} from '../../../../../node_modules/dynamic-forms-lib';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  isDevMode,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

import { RegistroService } from '../../../services/establecimiento/registro.service';
import { ProductosService } from '../../../services/productos/productos.service';

// Para usar el guard que alerta sobre cambios sin guardar.
import { FormComponent } from '../../form-component/form-component.class';

@Component({
  templateUrl: './registro-establecimiento.component.html',
  styleUrls: ['./registro-establecimiento.component.css'],
  providers: [ConfirmationService],
})
export class RegistroEstablecimientoComponent
  extends FormComponent
  implements OnInit
{
  breadCrumbItems: any[];

  /**
   * Acá se declaran las variables a utilizar en el resto de las funciones del componente, importante énfasis en las siguientes:
   *
   * code: Código del mensaje de respuesta a mostrar en la función.
   * titulo: Título a enviar; solo si se recibe con la respuesta del endpoint.
   * detalle: Detalle a enviar; solo si se recibe con la respuesta del endpoint.
   */

  form: DynamicForm;
  obsGeneral: any[] = [];
  formValid: any;
  visibleSpinner = false;
  visibleForm = false;
  stepEvent = 1;
  id: string;
  env = true;
  process: any;
  msg: any;
  numeroSolicitud: string;
  tramite: string;
  typeProceso: any;
  generarformulario = false;
  nummandamiento = 0;
  from_mandamiento = false;
  private messageTimeout: any;

  // Versión proceso.
  versionProceso: string;

  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  // Es editable
  editable = true;

  // Loading
  loadedCount = 0;
  loadCount = 0;
  loadCatalogs: string[] = [];

  //    events = new EventEmitter<DynamicFormEvent>();
  @Output() events: EventEmitter<DynamicFormEvent> =
    new EventEmitter<DynamicFormEvent>();

  constructor(
    private dynamicFormsSevice: DynamicFormService,
    private route: ActivatedRoute,
    private registroFarmaceuticoService: RegistroService,
    private productosFarmaceuticoService: ProductosService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    this.sw = 'Start';
    this.visibleSpinner = true;
    this.visibleForm = false;
    this.generarformulario = false;
    // Se recupera el json del formulario del proceso
    const proceso = this.route.snapshot.paramMap.get('proceso').toUpperCase();
    const inscripcion =
      this.route.snapshot.paramMap.get('inscripcion') !== null
        ? this.route.snapshot.paramMap.get('inscripcion').toLowerCase()
        : 'consulta';
    this.typeProceso = proceso.indexOf('TEMPORAL');
    this.navDetect(proceso, inscripcion);

    if (this.id) {
      this.registroFarmaceuticoService
        .recuperarInstancia(this.id)
        .subscribe((resInstancia: any) => {
          if (resInstancia.success) {
            const instancia = resInstancia.data.instancia;

            this.numeroSolicitud = instancia.numero_solicitud;
            this.tramite = instancia.nombre_proceso;

            this.versionProceso = instancia.codigo_version;
            const datos = JSON.parse(instancia.plantilla_form_solicitud);
            // datos.params = {
            //   readOnlySteps: false,
            //   enabledPrevNextButtons: true,
            // };

            datos.params  = datos.params ?
              {
                ...datos.params,
                ...{
                  readOnlySteps: false,
                  enabledPrevNextButtons: true,
                }
              } :
              {
                readOnlySteps: false,
                enabledPrevNextButtons: true,
              };
            datos.data = JSON.parse(instancia.datos_solicitud);
            this.dynamicFormsSevice.setEstadoInstancia(instancia.codigo_estado_proceso, ['OBSERVACION.FORMA', 'OBSERVACION.FONDO'].includes(instancia.codigo_estado_proceso) ? instancia.revision.created_at : null);
            this.editable = [
              'NUEVA.SOLICITUD',
              'OBSERVACION.FORMA',
              'OBSERVACION.FONDO',
            ].includes(instancia.codigo_estado_proceso);

            if (instancia.codigo_estado_proceso === 'OBSERVACION.FORMA') {
              // emitiendo el evento para saber si es observacion forma
              setTimeout(() => {
                this.events.emit({
                  type: 'estado-solicitud',
                  form: null,
                  action: instancia.codigo_estado_proceso,
                });
              }, 0);

              const observacionesWithKey = {};
              datos.observationData = JSON.parse(
                instancia.revision.observacion_campos
              );
              let observacionesCampo = JSON.parse(
                instancia.revision.observacion_campos
              );
              for (var key in observacionesCampo) {
                if (!Array.isArray(observacionesWithKey[key])){
                  observacionesWithKey[key] = [];
                }

                if (Array.isArray(observacionesCampo[key])){
                  observacionesCampo[key].forEach(observacion => {
                    if(observacion.hasOwnProperty('dictamen') && observacion.hasOwnProperty('value')){
                      observacionesWithKey[key].push(observacion);
                    }
                 });
                }else{
                  const subitem = {
                    dictamen: 'Revisión previa',
                    value: observacionesCampo[key],
                  };

                  observacionesWithKey[key].push(subitem);
                }
              }
              datos.commentable = false;
              datos.observationData = observacionesWithKey;
              this.obsGeneral = [];
              const subitemGeneral = {
                dictamen: 'Revisión previa',
                value: instancia.revision.observacion_general,
              };
              this.obsGeneral.push(subitemGeneral);
            } else if (
              instancia.codigo_estado_proceso === 'OBSERVACION.FONDO'
            ) {

              // emitiendo el evento para saber si es observacion fondo            
              setTimeout(() => {
                this.events.emit({
                  type: 'estado-solicitud',
                  form: null,
                  action: instancia.codigo_estado_proceso,
                });
              }, 0);

              const observacionesWithKey = {};
              this.obsGeneral = [];
              instancia.asignaciones.map((asignacion) => {
                let observacionesCampo = JSON.parse(
                  asignacion.observaciones.observacion_campos
                );
                let dictamen = asignacion.tipo_dictamen;
                for (var key in observacionesCampo) {
                  if (!Array.isArray(observacionesWithKey[key])){
                    observacionesWithKey[key] = [];
                  }

                  if (Array.isArray(observacionesCampo[key])){
                    observacionesCampo[key].forEach(observacion => {
                      if(observacion.hasOwnProperty('dictamen') && observacion.hasOwnProperty('value')){
                        observacionesWithKey[key].push(observacion);
                      }
                   });
                  }else{
                    const subitem = {
                      dictamen: dictamen.nombre_dictamen,
                      value: observacionesCampo[key],
                    };
                    observacionesWithKey[key].push(subitem);
                  }
                }
                const subitemGeneral = {
                  dictamen: dictamen.nombre_dictamen,
                  value: asignacion.observaciones.observacion_general,
                };
                this.obsGeneral.push(subitemGeneral);
                return asignacion;
              });

              datos.commentable = false;
              datos.observationData = observacionesWithKey;
            }
            datos.editable = this.editable;
            const response = this.dynamicFormsSevice.validateForm(datos);
            if (response.isValid) {
              this.form = response.form;
            } else {
              this.form = null;
              this.code = 'form.error.11';
              this.detalle = response.error;
            }

            this.dynamicFormsSevice.clearEstadoInstancia();
            this.enviarButtonDisabled(this.form.isValid());
            setTimeout(() => {
              /*
                          Si luego de 250ms loadCount sigue siendo cero, se oculta visibleSpinner, ya que
                          significa que no se encontró ningún componente dependiente para la carga. (Un select por ejemplo)
                      */
              if (this.loadCount === 0) {
                this.visibleSpinner = false;
                this.events.emit({
                  type: 'id-instancia',
                  form: null,
                  action: instancia.id,
                });
                this.events.emit({
                  type: 'codigo-proceso',
                  form: null,
                  action: proceso,
                });
              }
            }, 250);

            this.visibleForm = true;
          } else if (resInstancia.data.code === 2) {
            this.visibleSpinner = false;
            this.code = 'form.error.13';
            setTimeout(() => {
              this.router.navigate(['user/solicitudes/activas'], {
                queryParams: { skipUnsavedChangesGuard: true },
              });
            }, 2000);
          } else if (
            resInstancia.data.code === 42 ||
            resInstancia.data.code > 43
          ) {
            this.visibleSpinner = false;
            this.code = 'refresh.warn.default';
            setTimeout(() => {
              this.router.navigate(['auth/login']);
            }, 2000);
          }
        });
    } else {
      this.registroFarmaceuticoService.recuperarFormulario(proceso).subscribe(
        (res: any) => {
          if (res.success) {
            const data = res.data.data;
            this.versionProceso = data.codigo_version;
            this.tramite = data.nombre_proceso;
            const response = this.dynamicFormsSevice.validateForm(
              JSON.parse(data.plantilla_form_solicitud)
            );
            response.form.params = response.form.params ?
              {
                ...response.form.params,
                ...{
                  readOnlySteps: false,
                  enabledPrevNextButtons: true,
                }
              } :
              {
                readOnlySteps: false,
                enabledPrevNextButtons: true,
              };

            if (response.isValid) {
              this.form = response.form;
              setTimeout(() => {
                this.events.emit({
                  type: 'codigo-proceso',
                  form: null,
                  action: proceso,
                });
              }, 0);
            } else {
              this.form = null;
              this.code = 'form.error.11';
              this.detalle = response.error;
            }
            this.visibleSpinner = false;
            this.visibleForm = true;
          } else if (res.data.code === 42 || res.data.code > 43) {
            this.visibleSpinner = false;
            this.code = 'refresh.warn.default';
            setTimeout(() => {
              this.router.navigate(['auth/login']);
            }, 2000);
          }
        },
        (error) => {
          this.visibleSpinner = false;
          this.code = 'form.error.11';
          this.detalle = error;
        }
      );
    }
    if (isDevMode()) {
      setTimeout(() => {
        if (this.loadCatalogs.length > 0) {
          this.visibleSpinner = false;
        }
      }, 60000);
    }
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  navDetect(proceso, inscripcion): any {
    let label;
    let ProTittle;
    let routerLink;

    switch (inscripcion) {
      case 'cosmeticoshigienicos':
        ProTittle =
          'Productos ' + this.capitalizeFirstLetter(proceso.split('.')[2]);
        break;
      case 'dispositivos':
        ProTittle = 'Dispositivos Médicos';
        break;
      case 'quimicos':
        ProTittle = 'Productos Químicos';
        break;
      default:
        ProTittle = this.capitalizeFirstLetter(inscripcion);
    }

    if (proceso.includes('POSTREGISTRO') && inscripcion !== 'consulta') {
      label = ProTittle + ' (Trámites Post-Registro)';
      routerLink = '/post-registro/' + inscripcion;
    } else if (inscripcion === 'consulta') {
      label = 'Mis solicitudes';
      routerLink = '/user/solicitudes/activas'
    } else {
      label = 'Inscripción de ' + ProTittle;
      routerLink = '/' + inscripcion;
    }

    if (
      proceso.includes('POSTREGISTRO') &&
      inscripcion === 'establecimientos'
    ) {
      label = 'Modificación de Establecimientos';
      routerLink = '/registro/establecimientos/modificacion';
    }
    if (proceso.includes('INSCRIPCION') && inscripcion === 'establecimientos') {
      label = 'Apertura de Establecimientos';
      routerLink = '/registro/establecimientos/apertura';
    }
    if (proceso.includes('IMPORTADOR') && inscripcion === 'establecimientos') {
      label = 'Establecimientos';
      routerLink = '/establecimientos';
    }
    if (
      proceso.includes('CERTIFICACIONES') &&
      inscripcion === 'establecimientos'
    ) {
      label = 'Establecimientos';
      routerLink = '/establecimientos';
    }

    if (proceso.includes('POSTREGISTRO.ESTUPEFACIENTES')) {
      label = 'Unidad de Estupefacientes';
      routerLink = '/estupefacientes';
    }

    if (
      proceso.includes('LABORATORIOS.SOLICITUD') &&
      inscripcion === 'laboratorios'
    ) {
      label = 'Analisis de Laboratorio';
      routerLink = '/laboratorios';
    }

    this.breadCrumbItems = [
      {
        label: 'Usuario ventanilla',
        routerLink: '/inicio',
      },
      {
        label,
        routerLink,
      },
    ];

    if (proceso.includes('POSTREGISTRO.ESTUPEFACIENTES')) {
      if (
        proceso.includes('PREVISION_IMPORTACION') ||
        proceso.includes('CUOTA_COMPLEMENTARIA')
      ) {
        this.breadCrumbItems.push({
          label: 'Previsión de Importaciones',
          routerLink: '/post-registro/estupefacientes/prevision',
        });
      } else if (
        proceso.includes('DESCARGA_SP') ||
        proceso.includes('MUESTRA_PF') ||
        proceso.includes('DESTRUCCION_PF_SP')
      ) {
        this.breadCrumbItems.push({
          label:
            'Autorización para fabricación de medicamentos o productos controlados',
          routerLink: '/post-registro/estupefacientes/autorizacion-fabricacion',
        });
      } else if (
        proceso.includes('TRANSFERENCIA') ||
        proceso.includes('DEVOLUCIONES') ||
        proceso.includes('MUESTRA_LICITACION')
      ) {
        this.breadCrumbItems.push({
          label: 'Autorización de Comercialización',
          routerLink:
            '/post-registro/estupefacientes/autorizacion-comercializacion',
        });
      }
    }
  }

  capitalizeFirstLetter(str): any {
    return str[0].toUpperCase() + str.toLowerCase().slice(1);
  }

  enviarButtonDisabled(formulario): any {
    this.env = !formulario;
  }

  guardar(id, pro, emitirNumeroSolicitud = false): void {
    this.code = null;
    this.titulo = null;
    this.detalle = null;
    this.env = true;
    this.formValid = this.form.currentValue();
    if (pro === 'G') {
      // GUARDA DATA COMO BORRADOR
      this.registroFarmaceuticoService
        .guardarDatosFormulario(
          id,
          this.versionProceso,
          JSON.stringify(this.formValid)
        )
        .subscribe(
          (res: any) => {
            if (res.success) {
              if (res.data.code === 0) {
                this.visibleSpinner = false;
                this.detalle = null;
                this.form.setTouched(false);
                if (id === null) {
                  this.id = res.data.data.id;
                  this.code = 'form.success.11';
                  this.numeroSolicitud = res.data.data.numero_solicitud;
                  this.detalle =
                    '<p>La solicitud se ha guardado satisfactoriamente, el número de solicitud creada es:</p><p><h3><strong>' +
                    res.data.data.numero_solicitud +
                    '</strong></h3></p>';
                  setTimeout(() => {
                    this.enviarButtonDisabled(this.form.isValid());
                  }, 4000);
                } else {
                  this.code = 'form.success.12';
                  setTimeout(() => {
                    this.enviarButtonDisabled(this.form.isValid());
                  }, 4000);
                }
                this.id = res.data.data.id;
                if (this.generarformulario) {
                  this.enviarButtonDisabled(this.form.isValid());
                  this.visibleSpinner = true;
                  if (!this.from_mandamiento){
                    this.generarFormularioPF(this.nummandamiento);
                  } else {
                    this.from_mandamiento = false;
                    this.visibleSpinner = false;
                  }
                }
              } else {
                this.generarformulario = false;
                this.onmessage(
                  false,
                  'form.warn.11',
                  res.data.title,
                  res.data.message
                );
              }
            } else {
              this.generarformulario = false;
              this.onmessage(
                false,
                'form.warn.11',
                res.data.title,
                res.data.message
              );
            }

            this.events.emit({
              type: 'form-saved',
              form: null,
              action: this.id,
            });

            //Validación para emitir Numero de solicitud al generar el mandamiento de pago
            if (emitirNumeroSolicitud) {
              this.events.emit({
                type: 'return-numero-solicitud',
                form: null,
                action: res.data.data.numero_solicitud,
              });
            }
          },
          (error) => {
            this.generarformulario = false;
            this.visibleSpinner = false;
            this.code = 'form.error.12';
            this.detalle = error;
          }
        );
    } else if (pro === 'E') {
      // GUARDAMOS LA INFORMACIÓN Y LUEGO ENVIAMOS LA SOLICITUD
      this.registroFarmaceuticoService
        .guardarDatosFormulario(
          id,
          this.versionProceso,
          JSON.stringify(this.formValid)
        )
        .subscribe(
          (res: any) => {
            if (res.success) {
              if (res.data.code === 0) {
                this.id = res.data.data.id;
                this.enviarDataSolicitud(this.id);
              } else {
                this.onmessage(
                  false,
                  'form.warn.11',
                  res.data.title,
                  res.data.message
                );
              }
            } else {
              this.onmessage(
                false,
                'form.warn.11',
                res.data.title,
                res.data.message
              );
            }
          },
          (error) => {
            this.visibleSpinner = false;
            this.code = 'form.error.12';
            this.detalle = error;
          }
        );
    }
  }
  enviarDataSolicitud(id): void {
    this.registroFarmaceuticoService.enviarSolicitud(id).subscribe(
      (res: any) => {
        if (res.success) {
          if (res.data.code === 0) {
            this.visibleSpinner = false;
            this.form.setTouched(false);
            this.code = 'form.success.13';
            this.detalle =
              '<p>La solicitud <strong>' +
              res.data.numero_solicitud +
              '</strong> se ha enviado satisfactoriamente</p>';
            this.editable = false;
            setTimeout(() => {
              this.router.navigate(['user/solicitudes/activas']);
            }, 3000);
          } else {
            this.onmessage(
              false,
              'form.warn.11',
              res.data.title,
              res.data.message
            );
          }
        } else {
          this.onmessage(
            false,
            'form.warn.11',
            res.data.title,
            res.data.message
          );
        }
      },
      (error) => {
        this.visibleSpinner = false;
        this.code = 'form.error.12';
        this.detalle = error;
      }
    );
  }

  onmessage(visible, code, title, detalle): void {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
    this.visibleSpinner = visible;
    this.code = code;
    this.titulo = title;
    this.detalle = detalle;

    if (code) {
      this.messageTimeout = setTimeout(() => {
        this.code = null;
        this.titulo = null;
        this.detalle = null;
      }, 1000);
    }
  }

  onSave(emitirNumeroSolicitud = false): void {
    this.code = null;
    this.titulo = null;
    this.detalle = null;
    this.visibleSpinner = true;
    this.visibleForm = true;
    const post = this.versionProceso.includes('POSTREGISTRO');
    this.formValid = this.form.currentValue();
    if (
      (Object.keys(this.formValid).length === 0 &&
        this.formValid.constructor === Object) ||
      (post &&
        Object.keys(this.formValid).length <= 1 &&
        this.formValid.constructor === Object)
    ) {
      this.visibleSpinner = false;
      this.code = 'form.warn.13';
      this.generarformulario = false;
    } else if (
      this.typeProceso !== -1 &&
      !this.formValid.responsable_temporal___poder___otorgante___otorgante
    ) {
      this.visibleSpinner = false;
      this.code = 'form.warn.16';
      this.generarformulario = false;
    } else if (this.id) {
      this.guardar(this.id, 'G', emitirNumeroSolicitud);
    } else {
      this.guardar(null, 'G', emitirNumeroSolicitud);
    }

    setTimeout(() => {
      this.code = null;
    }, 500);
  }

  enviar(): void {
    this.code = null;
    this.titulo = null;
    this.detalle = null;
    this.visibleSpinner = true;
    this.formValid = this.form.isValid();
    if (this.formValid === false) {
      this.visibleSpinner = false;

      const errorList = this.form.isValidWithLabels([
        'crud-v3-table',
        'crud-v5-table',
        'crud-v7-table-documentos',
      ]);
      let msg = '';
      errorList.forEach((item) => {
        msg += '- ' + item + '<br>';
      });
      this.code = 'form.warn.14';
      this.detalle =
        'La solicitud no se puede enviar hasta completar todos los <b>campos requeridos</b>. <br><br> Verifique los siguientes campos: <br>' +
        msg;
      setTimeout(() => {
        this.code = null;
      }, 1000);
    } else if (this.id === null) {
      this.visibleSpinner = false;
      this.code = 'form.warn.15';
    } else {
      this.guardar(this.id, 'E');
    }

    setTimeout(() => {
      this.code = null;
    }, 500);
  }

  onFormEvent($event: DynamicFormEvent): void {
    if ($event.type === 'generar-declaracion-composicion-quimica') {
      this.generarFormularioPQ();
    } else if (Object.values($event)[0] === 'step-change') {
      this.sw = 'Start';
      const stepNumber: number = +Object.values($event)[2];
      this.stepEvent = stepNumber;
    } else if (Object.values($event)[0] === 'gestionar-documentos') {
      setTimeout(() => {
        this.onSave(Object.values($event)[2]);
      }, 0);
    } else if (Object.values($event)[0] === 'save-form') {
      setTimeout(() => {
        this.onSave(false);
      }, 0);
    } else if (Object.values($event)[0] === 'request-generate-mandamiento') {
        const formCodigosModelos = this.findComponentByIdentifier(this.form, 'modificacion_codigo___fieldset_codigos_modelos___codigos_modelos');
        const errors = formCodigosModelos?.value?.errors
        if (errors && Array.isArray(errors) && errors.length > 0) {
        this.onmessage(
          false,
          'form.warn.14',
          'Error de Validación',
          'No se puede generar el mandamiento porque existen errores pendientes:<br> - ' + errors.join('<br> - ')
        );
        return;
      }

      this.events.emit({ type: 'mandamiento-generado', form: $event.form, action: $event.action });

      this.from_mandamiento = true;
      this.onSave(Object.values($event)[2]);
      setTimeout(() => {
        this.events.emit({ type: 'edit-options-mandamiento', form: null, action: false });
      }, 0);
    } else if (Object.values($event)[0] === 'mandamiento-generado') {
      this.from_mandamiento = true;
      this.onSave(Object.values($event)[2]);

      // se emite evento para bloquear opciones que cambian el mandamiento
      setTimeout(() => {
        this.events.emit({
          type: 'edit-options-mandamiento',
          form: null,
          action: false,
        });
      }, 0);
      
      // Se recibe loaded-catalog para inidicar que el componente que bloquea el spinner se ha cargado
    } else if ((Object.values($event)[0] === 'loaded-catalog' || Object.values($event)[0] === 'loaded-documents') && this.id) {
      this.loadedCount += 1;
      this.validateLoadigCatalogs($event.form.identifier, 'remove');
      if (this.loadedCount >= this.loadCount) {
        this.visibleSpinner = false;
      }
      this.visibleSpinner = false;
      // Se recibe loading-catalog para agregar un nuevo componente que bloquee el spinner de carga
    } else if ((Object.values($event)[0] === 'loading-catalog' || Object.values($event)[0] === 'loading-documents')&& this.id) {
      this.loadCount += 1;
      this.validateLoadigCatalogs($event.form.identifier, 'add');
      // Se oculta spinner ya que hay componentes dependientes para el bloqueo
      this.visibleSpinner = true;
    } else if (
      Object.values($event)[0] === 'value-change' &&
      this.id &&
      $event.form &&
      $event.form?.name === 'formulario'
    ) {
      // Si se carga el formulario se verifica si se habilita el boton de enviar
      this.enviarButtonDisabled(this.form.isValid());
    } else if (Object.values($event)[0] === 'generar-formulario') {
      // isValid recibe un array de type de componentes a excluir en la validación
      this.formValid = this.form.isValid([
        'crud-v2-cat-documentos-coshig',
        'formulario',
      ]);
      if (this.formValid) {
        if (this.editable) {
          if (!Object.values($event)[1]) {
            this.generarformulario = true;
            this.onSave();
          } else {
            this.generarformulario = true;
            const numeroMandamiento = this.getEventValue($event);
            if(numeroMandamiento){
              this.nummandamiento = numeroMandamiento;
            }
            this.onSave();
          }
        } else {
          const id = this.getEventValue($event);
          if(id){
            // Solo se genera el formulario si la solicitud no es editable
            this.visibleSpinner = true;
            this.generarFormularioPF(id);
          }

        }
      } else {
        const errorList = this.form.isValidWithLabels([
          'crud-v2-cat-documentos-coshig',
          'crud-v7-table-documentos',
          'crud-v3-table',
          'formulario',
        ]);
        let msg = '';
        errorList.forEach((item) => {
          msg += '- ' + item + '<br>';
        });
        this.code = 'form.error.11';
        this.detalle =
          'Debe completar la solicitud antes de generar el formulario. <br><br> Verifique los siguientes campos: <br>' +
          msg;
        this.events.emit({ type: 'not-generated-formulario', form: this.form });
        setTimeout(() => {
          this.code = null;
        }, 1000);
      }
    } else if (Object.values($event)[0] === 'bloquear-solicitud') {
      this.editable = false;
      //Se bloquean botones de envio y guardar
    }
  }

  getEventValue($event) : any {
    const eventElement = this.getEventForm($event);

      if(eventElement && (eventElement.currentValue !== undefined)){
        const currentValue = eventElement.currentValue();

        if(currentValue && Array.isArray(currentValue) && currentValue.length > 0){
          return currentValue[0];
        }
      }

    return null;
  }


  getEventForm($event): any
  {
    if($event && Object.values($event).length > 1 ){
      return Object.values($event)[1];
    }
    return null;
  }

  validateLoadigCatalogs(identifier: string, action: string): void {
    if (action === 'add') {
      this.loadCatalogs.push(identifier);
    } else {
      for (let i = this.loadCatalogs.length; i--; ) {
        if (this.loadCatalogs[i] === identifier) {
          this.loadCatalogs.splice(i, 1);
        }
      }
    }
  }

  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'popup-edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'popup-opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'popup-chrome';
      case agent.indexOf('trident') > -1:
        return 'popup-ie';
      case agent.indexOf('firefox') > -1:
        return 'popup-ff';
      case agent.indexOf('safari') > -1:
        return 'popup-safari';
    }
  }

  generarFormularioPF(id): any {
    const isPRProductos =
      this.versionProceso.includes('POSTREGISTRO.PRODUCTOS') ||
      this.versionProceso.includes('POSTREGISTRO.ESTUPEFACIENTES');

    id = isPRProductos ? this.id : id;
    if (id == 0) {
      id = this.id;
    }
    this.productosFarmaceuticoService
      .generarFormulario(id, isPRProductos)
      .subscribe(
        (response: any) => {
          this.visibleSpinner = false;
          this.generarformulario = false;

          if(response?.type === 'application/json'){
            this.mostrarErrorGeneracionFormulario();
          }else {
            this.events.emit({ type: 'generated-formulario', form: this.form });
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            var form_wd = window.open(url);
            try {
              form_wd.focus();
            } catch (e) {
              const img_src = this.getBrowserName();
              this.confirmationService.confirm({
                message:
                  'Para poder visualizar el formulario, por favor desbloquee la ventana emergente de su navegador y vuelva a intentarlo.<center><img src="assets/img/misc/' +
                  img_src +
                  '.png" width="800"></center>',
                header: 'Ventanas emergentes bloqueadas',
                rejectVisible: false,
                accept: () => {},
              });
            }
          }


        },
        (error) => {
          this.mostrarErrorGeneracionFormulario();
        }
      );
  }

  mostrarErrorGeneracionFormulario():void {
    this.events.emit({
      type: 'not-generated-formulario',
      form: this.form,
    });
    this.visibleSpinner = false;
    this.generarformulario = false;
    this.code = 'form.error.11';
    this.detalle = 'No se ha podido recuperar el formulario.';
  }

  generarFormularioPQ(): any {
    const form = this.form.currentValue();
    this.visibleSpinner = true;
    this.code = null;
    this.titulo = null;
    this.detalle = null;

    const sustancias = this.obtenerSustancias(form);

    const is_post = this.versionProceso.includes('POSTREGISTRO');
    let composicionQuimica: any;
    if (is_post) {
      composicionQuimica = {
        nombre:
          form?.ampliacion_composicion_quimica___datos___producto
            ?.nombre_registro ?? '',
        codigo:
          form?.ampliacion_composicion_quimica___datos___producto
            ?.codigos_producto ?? '',
        fabricante: this.obtenerFabricantesPosts(form),
        forma_expresion: this.obtenerFormaExpresion(form),
        sustancias: sustancias,
        controlado: sustancias.filter((s) => s.controlado == 1).length > 0,
        tipo_firmante: form[`${this.form.name}___detalles___firmantes___pregunta_inicial`] == 0
        ? (form?.ampliacion_composicion_quimica___titular___firmantes___tipo_firmante 
          ?? form[`${this.form.name}___detalles___firmantes___firmante___tipo_firmante`]
          ?? '')
        : 'FIRMANTE.INSCRIPCION',
        registro: form[`${this.form.name}___datos___producto`].id_producto
        ?? form[`${this.form.name}___datos___producto`].numero_registro
        ?? null
      };
    } else {
      composicionQuimica = {
        nombre:
          form?.producto_quimico___producto___nombre ??
          form?.ampliacion_composicion_quimica___datos___producto
            ?.nombre_registro,
        codigo:
          form?.producto_quimico___informacion___codigo
          ? form?.producto_quimico___informacion___codigo
          : '',
      fabricante: this.obtenerFabricantesRegistro(form),
      forma_expresion: this.obtenerFormaExpresion(form),
        sustancias: sustancias,
        controlado: sustancias.filter((s) => s.controlado == 1).length > 0,
        tipo_firmante: form?.producto_quimico___titular___firmantes___tipo_firmante ?? 'REPRESENTANTE LEGAL'
      };
    }
    this.productosFarmaceuticoService
      .generarDeclaracionComposicionQuimica(composicionQuimica)
      .subscribe(
        (response: any) => {
          if (response.type === 'application/json') {
            response.text().then((text) => {
              this.detalle = JSON.parse(text).data.extra.join('<br>');
              this.visibleSpinner = false;
              this.titulo = 'Declaración de composición química';
              this.code = 'form.error.11';
              return;
            });
          } else {
            this.visibleSpinner = false;
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            var form_wd = window.open(url);
            try {
              form_wd.focus();
            } catch (e) {
              const img_src = this.getBrowserName();
              this.confirmationService.confirm({
                message:
                  'Para poder visualizar la declaración química, por favor desbloquee la ventana emergente de su navegador y vuelva a intentarlo.<center><img src="assets/img/misc/' +
                  img_src +
                  '.png" width="800"></center>',
                header: 'Ventanas emergentes bloqueadas',
                rejectVisible: false,
                accept: () => {},
              });
            }
          }
        },
        (error) => {
          this.visibleSpinner = false;
          this.code = 'form.error.11';
          this.titulo = 'Declaración química';
          this.detalle = 'No se ha podido recuperar la declaración química.';
        }
      );
  }

  obtenerFabricantesPosts(form): string {
    let nombresFabricantes = '';

    if (
      form?.ampliacion_composicion_quimica___datos___producto
        ?.fabricantes_producto?.length > 0
    ) {
      const fabricantes =
        form?.ampliacion_composicion_quimica___datos___producto.fabricantes_producto.filter(
          (f) => f.tipo == 'laboratorio.fabricante'
        );

      let cantidadFabricantes = 0;

      fabricantes.forEach(fabricante => {
        cantidadFabricantes++;

        if(cantidadFabricantes > 1) {
          nombresFabricantes = `${nombresFabricantes}<br>`;
        }

        nombresFabricantes = `${nombresFabricantes}${fabricante.nombre_establecimiento ?? 'No especificado'}`;
      });
    }

    return nombresFabricantes;
  }

  obtenerFabricantesRegistro(form): string {
    let nombresFabricantes = '';

    if (
      form?.producto_quimico___laboratorio_fabricante___lfqFieldsetInformacion___lfq
    ) {
    if (
      form
        ?.producto_quimico___laboratorio_fabricante___lfqFieldsetInformacion___lfq
        .length > 0
    ) {

      const fabricantes = form?.producto_quimico___laboratorio_fabricante___lfqFieldsetInformacion___lfq ?? [];

      let cantidadFabricantes = 0;

      fabricantes.forEach(fabricante => {
        cantidadFabricantes++;

        if(cantidadFabricantes > 1) {
          nombresFabricantes = `${nombresFabricantes}<br>`;
        }

        const nombreFabricante = fabricante?.hasOwnProperty('nombre_establecimiento')
          ? fabricante?.nombre_establecimiento
          : fabricante?.hasOwnProperty('nombre') ? fabricante?.nombre : '';

        const nombrePais = fabricante?.hasOwnProperty('municipio')
          ? fabricante?.municipio?.departamento?.pais?.nombre ?? ''
          : fabricante?.hasOwnProperty('pais_label') ? fabricante?.pais_label : '';

        nombresFabricantes = `${nombresFabricantes}${nombreFabricante}, ${nombrePais}`;
      });
      }
    }

    return nombresFabricantes;
  }

  obtenerSustancias(form) {
    if (
      form
        ?.producto_quimico___informacion___composicion_quimica___composicion_quimica
        ?.length ??
      0 > 0
    ) {
      return form
        ?.producto_quimico___informacion___composicion_quimica___composicion_quimica[0]
        .sustancias;
    } else if (
      form
        ?.ampliacion_composicion_quimica___composicion___composicion_quimica___composicion_quimica
        ?.length ??
      0 > 0
    ) {
      return form
        ?.ampliacion_composicion_quimica___composicion___composicion_quimica___composicion_quimica[0]
        .sustancias;
    }

    return [];
  }

  obtenerFormaExpresion(form) {
    if (
      form
        ?.producto_quimico___informacion___composicion_quimica___composicion_quimica
        ?.length ??
      0 > 0
    ) {
      return form
        ?.producto_quimico___informacion___composicion_quimica___composicion_quimica[0]
        .forma_expresion;
    } else if (
      form
        ?.ampliacion_composicion_quimica___composicion___composicion_quimica___composicion_quimica
        ?.length ??
      0 > 0
    ) {
      return form
        ?.ampliacion_composicion_quimica___composicion___composicion_quimica___composicion_quimica[0]
        .forma_expresion;
    }

    return '';
  }

  private findComponentByIdentifier(form: DynamicForm, identifier: string): DynamicForm | null {
    if (!form) {
      return null;
    }
    if (form.identifier === identifier) {
      return form;
    }
    if (form.forms && Array.isArray(form.forms)) {
      for (const subForm of form.forms) {
        const found = this.findComponentByIdentifier(subForm, identifier);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }
}
